import type {
	ThirdPartyEntityStatuses,
	ThirdPartyEntityStatusesState,
	ThirdPartyStatusState,
} from '../../common/types';

export const transformToStatusMappingState = (
	statusResponse: ThirdPartyEntityStatuses,
): ThirdPartyEntityStatusesState => {
	const mapping: ThirdPartyEntityStatusesState['entityStatusMappings'] = {};

	statusResponse.entityStatusMappings.forEach((entityStatusMapping) => {
		const statusMappings = entityStatusMapping.statusMappings.reduce(
			(acc: ThirdPartyStatusState, status) => {
				acc[status.sourceStatusName] = {
					mappedStatusName: status.mappedStatusName,
					statusCategory: status.statusCategory,
				};
				return acc;
			},
			{},
		);

		mapping[entityStatusMapping.entityName] = {
			entityId: entityStatusMapping.entityId,
			statusMappings,
		};
	});
	return {
		availableJiraStatuses: statusResponse.availableJiraStatuses,
		statusOptions: statusResponse.statusOptions,
		entityStatusMappings: mapping,
	};
};
